import moment from "moment";
import { patchWorkerTimesheetRow } from "store/actions/rostering.actions";

/** Match backend NestedTimeSheetResource time_matched logic. */
export const computeTimesheetTimeMatched = (startTime, workerStartTime) => {
  if (!startTime || !workerStartTime) return false;
  const scheduled = moment(startTime);
  const actual = moment(workerStartTime);
  if (!scheduled.isValid() || !actual.isValid()) return false;
  return (
    scheduled.format("YYYY-MM-DD HH:mm") === actual.format("YYYY-MM-DD HH:mm")
  );
};

/** Fields from detail-update / code-allocation response that the table row displays. */
export const buildTimesheetTableRowPatch = (detail) => {
  if (!detail?.uuid) return null;

  const patch = {
    uuid: detail.uuid,
    start_time: detail.start_time,
    end_time: detail.end_time,
    worker_start_time: detail.worker_start_time,
    worker_end_time: detail.worker_end_time,
    timesheet_length: detail.timesheet_length,
    time_matched: computeTimesheetTimeMatched(
      detail.start_time,
      detail.worker_start_time
    ),
  };

  // Advance rows render the worker's slot, so it has to travel with the patch.
  if (detail.advance_slot !== undefined) {
    patch.advance_slot = detail.advance_slot;
    patch.is_advance_shift = Boolean(
      detail.is_advance_shift ?? detail.is_v5_multi_assignment
    );
  }

  if (detail.time_sheet_date != null) {
    patch.shift_date = detail.time_sheet_date;
  }
  if (detail.km != null) {
    patch.km = detail.km;
  }
  if (detail.status != null) {
    patch.status = detail.status;
  }

  return patch;
};

export const syncTimesheetTableRowFromDetail = (dispatch, detail) => {
  const patch = buildTimesheetTableRowPatch(detail);
  if (!patch) return;
  dispatch(patchWorkerTimesheetRow(patch));
};
